import React, { FC } from "react";
import { SubjectCard } from "./SubjectCard";
import { ISubjectFrontEndModel } from "../types";
import { useWizard } from "../../wizard/context";
import { Grid, makeStyles } from "@material-ui/core";

interface ISubjectsListProps {
  subjectsList: ISubjectFrontEndModel[];
}

const useStyles = makeStyles(() => ({
  subjectCard: {
    minWidth: 600,
  },
}));

const SubjectsList: FC<ISubjectsListProps> = ({ subjectsList }) => {
  const classes = useStyles();

  const { openWizard } = useWizard();

  const chooseTeacher = () => {
    openWizard({
      steps: [
        {
          titleConfig: {
            titleText: "Oops",
          },
          content: "We're sorry, no teacher is currently available.",
        },
      ],
      submitButtonText: null,
      cancelButtonText: "Close",
    });
  };

  return (
    <Grid container spacing={2}>
      {subjectsList.map((subject) => (
        <Grid item xs={12} sm={12} md={6} className={classes.subjectCard}>
          <SubjectCard
            key={subject.id}
            subject={subject}
            onChooseTeacher={chooseTeacher}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default React.memo(SubjectsList);
